module.exports = __webpack_public_path__ + "static/noticias-16--8b1e254af7ecd15099fb32ceaf8eb064.png";